import React from 'react';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import DetailsCard from '@rental-manager/components/DetailsCard';
import { IPropertyInfoModel } from '@rental-manager/models/Types';

type PrimaryTenantProps = {
  rentTerms: IPropertyInfoModel;
  userEvent: any;
  goToEditTenantInfoPage: (rentTerms: IPropertyInfoModel) => void;
  goToNewTermPage: () => void;
};

class PrimaryTenant extends React.Component<PrimaryTenantProps> {
  goToEditPage = (): void => {
    const { goToEditTenantInfoPage, rentTerms } = this.props;
    goToEditTenantInfoPage(rentTerms);
  };

  render(): React.ReactNode {
    const { rentTerms, userEvent = {}, goToNewTermPage } = this.props;
    const { tenantName, tenantFirstName, tenantEmail, tenantOnBoarded, termEnded } = rentTerms;
    const { message } = userEvent;
    return (
      <DetailsCard title="Primary tenant" onEdit={this.goToEditPage} showEdit={!tenantOnBoarded && !termEnded}>
        <Text className="fs-exclude">{tenantName}</Text>
        <Text className="fs-exclude txtWrap">{tenantEmail}</Text>
        {message && (
          <Text type="body-tiny" className="Dashboard-userEventMessage pvs">
            {message}
          </Text>
        )}
        {termEnded && (
          <Link onClick={goToNewTermPage} type="secondary">
            Invite a new tenant
          </Link>
        )}
        {tenantOnBoarded && !termEnded && tenantEmail && (
          <Link href={`mailto: ${tenantEmail}`}>Contact {tenantFirstName}</Link>
        )}
      </DetailsCard>
    );
  }
}
export default PrimaryTenant;
